import { render } from "./SideNotes.vue?vue&type=template&id=67d0960e&scoped=true"
import script from "./SideNotes.vue?vue&type=script&lang=js"
export * from "./SideNotes.vue?vue&type=script&lang=js"

import "./SideNotes.vue?vue&type=style&index=0&id=67d0960e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d0960e"]])

export default __exports__